import React from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import assets from "../../../util/assets";
import PropTypes from "prop-types";

const CommonContainerModal = (props) => {

    return (
        <Modal isOpen={props.isOpen} >
            {
                props.title.length > 0 &&
                <ModalHeader className="border-0 " id="upload-file-modal">
                <span className="text-center mb-2 modal-container-title">
                    {props.title}
                </span>
                    <img src={assets.broadcast.cross}
                         alt={"cross icon"}
                         onClick={() => {
                             props.toggle();
                         }}/>
                </ModalHeader>
            }
            <ModalBody className="justify-content-center">
                {props.children}
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">

            </ModalFooter>
        </Modal>
    );
}

CommonContainerModal.propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
};

export default CommonContainerModal;

